import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Breadcrumb } from "..";
import IconBoxClose from "assets/icon/IconBoxClose.svg";
// import IconBoxCloseGray from "assets/icon/IconBoxCloseGray.svg";
import { useHistory } from "react-router";
import { useNotificationList } from "hooks/use-notification";
import { useNotificationUpdate } from "hooks/use-notification";

import "./styles.scss";

import JwtDecode from "jwt-decode";

const AdminNav = ({ pageTitle, breadcrumbItems, noIcon, backIcon }) => {
  const isToken = localStorage.getItem("accessToken");
  let decodeToken = JwtDecode(isToken);
  const history = useHistory();
  const userName = decodeToken.name;
  const [open, setOpen] = React.useState(false);

  const { data: getNotif } = useNotificationList();
  const { mutate } = useNotificationUpdate(
    {
      onSuccess: () => {
        history.go(0);
      },
    },
    {
      onError: () => {
        console.log("error");
      },
    }
  );

  const toggleDropdown = () => {
    setOpen(!open);
  };

  const onSubmit = (id) => {
    mutate({ id });
  };

  const notificationContent = () => (
    <Dropdown.Menu className="pt-0 admin__notification">
      <div className="d-flex justify-content-between header">
        <h4 style={{ color: "#ffff" }}>Notifikasi</h4>
        <h6
          style={{ color: "#ffff" }}
          className="cursor-pointer"
          onClick={() => history.push("/notification-center")}
        >
          Lihat Semua
        </h6>
      </div>
      <div className="notification-list-wrapper">
        {getNotif?.data?.notifications?.length === 0 ? (
          <div className=" flex justify-content-center py-3"> Tidak Ada Notifikasi</div>
        ) : (
          getNotif?.data?.notifications?.map((item) => {
            return (
              <Dropdown.Item
                key={item.id} className={`nofification-item py-3 ${item?.already_read === false ? "active" : ""}`}
                onClick={() => {
                  onSubmit(item.id);
                  history.push(`/${item?.link?.split("://")[1].split("/").slice(1).join("/")}`);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className={`icon-wrapper ${item?.already_read === false ? "active" : ""}`}>
                    <img src={IconBoxClose} alt="notif" />
                  </div>
                  <div className="ms-3">
                    <h5 className="title mb-1">{item?.notification?.title}</h5>
                    <p className="description mb-2">{item?.notification?.body}</p>
                    {/* <span className="time">1d Ago</span> */}
                  </div>
                </div>
              </Dropdown.Item>
            );
          })
        )}
      </div>
    </Dropdown.Menu>
  );

  return (
    <header className="admin__header">
      {breadcrumbItems ? (
        <Breadcrumb items={breadcrumbItems} />
      ) : (
        <h1
          onClick={backIcon ? () => history.goBack() : undefined}
          className={`${backIcon ? "d-flex align-items-center cursor-pointer" : ""}`}
        >
          {backIcon && (
            <div className="me-2">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="Arrow_left">
                  <path
                    id="Vector 9"
                    d="M10 6L4 12M4 12L10 18M4 12H19"
                    stroke="#E9522A"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </div>
          )}
          {pageTitle}
        </h1>
      )}

      <div className="admin__header-content">
        {/* <button type="button">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="11" cy="11" r="7" stroke="#455673" strokeWidth="2" />
            <path d="M20 20L17 17" stroke="#455673" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button> */}

        <Dropdown show={open} onToggle={toggleDropdown} align="end">
          <Dropdown.Toggle className="transparent-btn">
            <svg
              width="24"
              height="24"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.61 3.61183C17.5222 3.05954 16.294 2.75 15 2.75C10.9323 2.75 7.51511 5.80853 7.06591 9.85134L6.75116 12.6841C6.69796 13.1629 6.6753 13.3634 6.64216 13.5577C6.51903 14.2799 6.28329 14.9783 5.94356 15.6274C5.85213 15.802 5.74866 15.9752 5.50082 16.3883L4.70989 17.7065L4.67239 17.769C4.30178 18.3865 3.96733 18.9438 3.7731 19.4121C3.56959 19.9028 3.40084 20.5732 3.77578 21.2354C4.15072 21.8976 4.81235 22.0978 5.33784 22.1758C5.83936 22.2502 6.48928 22.2501 7.20947 22.25H7.20949L7.28237 22.25H22.7176L22.7905 22.25H22.7905C23.5107 22.2501 24.1606 22.2502 24.6621 22.1758C25.1876 22.0978 25.8493 21.8976 26.2242 21.2354C26.5991 20.5732 26.4304 19.9028 26.2269 19.4121C26.0327 18.9438 25.6982 18.3865 25.3276 17.769L25.2901 17.7065L24.4992 16.3883C24.2513 15.9752 24.1479 15.802 24.0564 15.6274C23.7167 14.9783 23.481 14.2799 23.3578 13.5577C23.3315 13.4031 23.3117 13.2447 23.278 12.9454C23.0238 12.9814 22.7641 13 22.5 13C22.0721 13 21.6557 12.9511 21.2559 12.8587L21.2611 12.905L21.2646 12.9372L21.2646 12.9373C21.3132 13.3744 21.3422 13.6353 21.3863 13.8939C21.5446 14.8224 21.8477 15.7203 22.2845 16.5548C22.4061 16.7872 22.5411 17.0122 22.7674 17.3894L22.7842 17.4173L23.5751 18.7355C23.9954 19.436 24.2491 19.8641 24.3795 20.1783L24.3862 20.1947L24.3686 20.1974C24.0322 20.2473 23.5345 20.25 22.7176 20.25H7.28237C6.46548 20.25 5.96783 20.2473 5.63135 20.1974L5.61378 20.1947L5.62053 20.1783C5.75084 19.8641 6.00459 19.436 6.42488 18.7355L7.2158 17.4173L7.23252 17.3894L7.23253 17.3894C7.45883 17.0123 7.59387 16.7872 7.71551 16.5548C8.15231 15.7203 8.4554 14.8224 8.61371 13.8939C8.65779 13.6353 8.68677 13.3745 8.73533 12.9373L8.73533 12.9373L8.73892 12.905L9.05368 10.0722C9.39034 7.04226 11.9514 4.75 15 4.75C15.876 4.75 16.7117 4.93927 17.466 5.28092C17.7425 4.65454 18.1326 4.08949 18.61 3.61183ZM21.0174 5.48683C20.4136 5.93228 20.0173 6.64293 20.0005 7.44687C20.3772 8.01924 20.6589 8.66176 20.8221 9.35333C21.2657 9.7552 21.8543 10 22.5 10C22.6523 10 22.8014 9.98638 22.9462 9.9603L22.9341 9.85134C22.7483 8.1792 22.0547 6.67544 21.0174 5.48683ZM24.4466 20.3876C24.4464 20.3875 24.4461 20.3849 24.4459 20.3803C24.4467 20.3854 24.4467 20.3877 24.4466 20.3876ZM24.5826 20.1473C24.5825 20.1472 24.5801 20.1482 24.576 20.1505C24.5796 20.149 24.5817 20.148 24.5824 20.1475C24.5826 20.1474 24.5827 20.1473 24.5826 20.1473ZM5.41734 20.1473C5.41752 20.1472 5.41989 20.1482 5.42394 20.1505C5.41919 20.1485 5.41716 20.1474 5.41734 20.1473ZM5.55376 20.3854C5.55389 20.3842 5.554 20.3825 5.55406 20.3803C5.55331 20.3854 5.55324 20.3877 5.5534 20.3876C5.55348 20.3875 5.55363 20.3868 5.55376 20.3854Z"
                fill="#455673"
              />
              <path
                d="M11.3778 22.0809C11.5914 23.2769 12.0622 24.3338 12.7171 25.0876C13.3721 25.8414 14.1745 26.25 15 26.25C15.8255 26.25 16.6279 25.8414 17.2829 25.0876C17.9378 24.3338 18.4086 23.2769 18.6222 22.0809"
                stroke="#455673"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <circle cx="22.5" cy="7.5" r="3" fill="#E9522A" stroke="#E9522A" />
            </svg>
          </Dropdown.Toggle>
          {notificationContent()}
        </Dropdown>

        <button type="button">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="10" r="3" fill="#455673" />
            <circle cx="12" cy="12" r="9" stroke="#455673" strokeWidth="2" />
            <path
              d="M17.7805 18.8264C17.9076 18.7566 17.9678 18.6055 17.914 18.4708C17.5284 17.5045 16.7856 16.6534 15.7814 16.0332C14.6966 15.3632 13.3674 15 12 15C10.6326 15 9.30341 15.3632 8.21858 16.0332C7.21444 16.6534 6.4716 17.5045 6.08598 18.4708C6.03223 18.6055 6.09236 18.7566 6.21948 18.8264C9.81971 20.803 14.1803 20.803 17.7805 18.8264Z"
              fill="#455673"
            />
          </svg>
          <span>{userName}</span>
        </button>
      </div>
    </header>
  );
};

export default AdminNav;
